module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_5010.483a6ddd.png";